module.exports = __webpack_public_path__ + "static/media/D76FA00D-3407-407D-BF9A-6F4EAA89422C.95fa1189.JPG";